const INITIAL_STATE = {
    status: 'done',
    message: null,
    status_recover: 'done',
    message_recover: null,
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PASSWORD_CHANGED_STATUS':
            return { ...state, status: action.payload.status, message: action.payload.message }
        case 'PASSWORD_CHANGED_STATUS_RECOVER':
            return { ...state, status_recover: action.payload.status, message_recover: action.payload.message }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/reducers/passwordReducer.js